/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import ColorPicker from 'material/embeds/colorpicker/colorpicker';
import { Title } from '@insticator/insticator-ui'; // iui-material
import QuestionFormat from 'pages/dashboard/embeds/management/customize/cardproperties/questionproperties/questionformat/questionformat_container';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/management/customize/cardproperties/questionproperties/questionproperties_styles';



/* ========== ~~~~~~~~~~ EMBED QUESTION PROPERTIES ~~~~~~~~~~ ========== */
const QuestionProperties = (props) => {

    const displayFormatOptionsBasedOnContentType = () => {
        switch (props.contentType) {
            case 'poll':
                return [<QuestionFormat key={'emoji'} type={`emoji`} desc={`Emoji`} />];
            default:
                return null;
        }
    }
    const showPlacement = () => props.location === 'in-content' ? 'incontent' : 'rail';
    const setBackgroundColor = (color) => (props.setCurrentUniqueProperty(props.contentId, 'backgroundColor', color));

    return (
        <div className={`questionproperties ${props.classes.questionproperties} ${showPlacement()}`}>
            <div className={"questioncontainer"} >
                <Title name={'propertiestitle'} >
                    <h4>Question Style:</h4>
                </Title>
                <div className={`questionformatselector`}>
                    {/* below are common across questions */}
                    <QuestionFormat key={'image1'} type={`image1`} desc={`Round`} />
                    <QuestionFormat key={'image2'} type={`image2`} desc={`Large`} />
                    <QuestionFormat key={'text1'} type={`text1`} desc={`Text`} />
                    <QuestionFormat key={'text2'} type={`text2`} desc={`Text`} />
                    {/* content type specific */}
                    {displayFormatOptionsBasedOnContentType()}
                </div>
            </div>
            <div className={`background`}>
                <Title>
                    <h4>Background Color:</h4>
                </Title>
                <ColorPicker fadeInRight={true} color={props.backgroundColor} processColorUpdate={setBackgroundColor} />
            </div>
        </div>
    );
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(QuestionProperties);
